module.exports = __webpack_public_path__ + "static/media/Isabelle Powell.88722910.JPG";